import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StorageService } from '@core/services/storage/storage.service';
import { Toast } from "primeng/toast";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {

  private storageService = inject(StorageService);

  ngOnInit() {
    if (!this.storageService.existsCookie()) {
      this.storageService.setCookie();
    }

    
  }
}
